module.exports = __webpack_public_path__ + "media/images/careerplug_logo-8f33e1c6b753929cefc48d6c0ea338b4.png";